var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h5-page-eianFAQ"},[_c('p',{on:{"click":_vm.openFile}},[_vm._v("名称："+_vm._s(_vm.name))]),_c('div',{attrs:{"align":"center"}},[_c('button',{on:{"click":_vm.openFile}},[_vm._v("查看文件")])])])}
var staticRenderFns = []

export { render, staticRenderFns }